const OPERATOR_PREFIX = 'Operator-In'
const PREFIX_SEPARATOR = ':'
const VALUE_SEPARATOR = ','
const FULL_PREFIX = `${OPERATOR_PREFIX}${PREFIX_SEPARATOR}`

export function parseConditionalKeyIds(
  key: string | null | undefined,
): string[] {
  if (!key?.trim()) return []

  // Only treat as multi-key if it has the exact Operator-In: prefix
  if (!key.startsWith(FULL_PREFIX)) return [key]

  const idsStr = key.slice(FULL_PREFIX.length)
  if (!idsStr) return []

  return idsStr
    .split(VALUE_SEPARATOR)
    .map(s => s.trim())
    .filter(Boolean)
}

export function serializeConditionalKey(ids: string[]): string {
  if (ids.length === 0) return ''
  return `${FULL_PREFIX}${ids.join(VALUE_SEPARATOR)}`
}

export function matchesConditionalKey(
  key: string | null | undefined,
  locationId: string | null | undefined,
): boolean {
  if (!key || !locationId) return false
  return parseConditionalKeyIds(key).includes(locationId)
}
